export const getBlocked = state => state.blocked;
export const getCurrent = state => state.current;
export const getItems = state => state.items;
export const getItemsLength = state => state.items.filter(item => item.display).length;
export const getVisibility = state => state.isVisible;

export default {
  getBlocked,
  getCurrent,
  getItems,
  getItemsLength,
  getVisibility
};



// WEBPACK FOOTER //
// ./src/store/modules/timeline/getters.js